

export class SelectApplicationSubMenuDemoTableOutputDataData implements ISelectApplicationSubMenuDemoTableOutputDataData {
    /** The auto-generated id of the tbl_application_sub_menu */
    application_sub_menu_id!: number;
    /** The sub menu name with 100 character limit */
    application_sub_menu!: string;
    /** The sub menu icon with 2048 character limit */
    application_sub_menu_url!: string;
    /** The sub menu type must be "OVERVIEW" or "DETAIL" */
    screen_type!: string;
    /** The index_number */
    application_sub_index_number!: number;
    /** The sub menu name with 100 character limit */
    application_menu!: string;
    /** The index_number */
    index_number!: number;

    constructor(data?: ISelectApplicationSubMenuDemoTableOutputDataData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application_sub_menu_id = _data["application_sub_menu_id"];
            this.application_sub_menu = _data["application_sub_menu"];
            this.application_sub_menu_url = _data["application_sub_menu_url"];
            this.screen_type = _data["screen_type"];
            this.application_sub_index_number = _data["application_sub_index_number"];
            this.application_menu = _data["application_menu"];
            this.index_number = _data["index_number"];
        }
    }

    static fromJS(data: any): SelectApplicationSubMenuDemoTableOutputDataData {
        data = typeof data === 'object' ? data : {};
        let result = new SelectApplicationSubMenuDemoTableOutputDataData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application_sub_menu_id"] = this.application_sub_menu_id;
        data["application_sub_menu"] = this.application_sub_menu;
        data["application_sub_menu_url"] = this.application_sub_menu_url;
        data["screen_type"] = this.screen_type;
        data["application_sub_index_number"] = this.application_sub_index_number;
        data["application_menu"] = this.application_menu;
        data["index_number"] = this.index_number;
        return data; 
    }
}

export interface ISelectApplicationSubMenuDemoTableOutputDataData {
    /** The auto-generated id of the tbl_application_sub_menu */
    application_sub_menu_id: number;
    /** The sub menu name with 100 character limit */
    application_sub_menu: string;
    /** The sub menu icon with 2048 character limit */
    application_sub_menu_url: string;
    /** The sub menu type must be "OVERVIEW" or "DETAIL" */
    screen_type: string;
    /** The index_number */
    application_sub_index_number: number;
    /** The sub menu name with 100 character limit */
    application_menu: string;
    /** The index_number */
    index_number: number;
}

